// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Code Components Area
export class AreaCodeComponents {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Fetches all remote code components in the version
     * @param from - Remote version to fetch from
     * @returns All components in the specified version
     */
    async getCodeComponents(from) {
        return this.dataCore.codeComponents(from.designSystemId, from.versionId);
    }
}
